"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledZillowHomeLogo = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fontColorMixin = require("../../mixins/fontColorMixin");
var StyledZillowHomeLogo = /*#__PURE__*/_styledComponents.default.svg.withConfig({
  displayName: "StyledZillowHomeLogo",
  componentId: "c11n-8-107-0__sc-1hmwaqs-0"
})(["", ""], _fontColorMixin.fontColorMixin);
exports.StyledZillowHomeLogo = StyledZillowHomeLogo;